import React from 'react';

/**
 * BrandLoader — the single loading screen for the guest menu.
 * Used BOTH as the lazy-load (Suspense) fallback AND as the menu's data-fetch
 * loading state, so the two phases render identical DOM and read as ONE
 * continuous loader. Language is taken from localStorage (set before data
 * loads), so the right text shows even during the very first paint.
 */
const BrandLoader = () => {
  let lang = 'en';
  try {
    lang = localStorage.getItem('menuLanguage') || 'en';
  } catch (e) {
    lang = 'en';
  }
  const isAr = lang === 'ar';

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      dir={isAr ? 'rtl' : 'ltr'}
      style={{ background: 'linear-gradient(135deg, #00594f 0%, #001614 140%)' }}
    >
      <div className="flex flex-col items-center gap-6">
        <div className="w-11 h-11 rounded-full border-2 border-ent-gold/25 border-t-ent-gold animate-spin" />
        <p className={`text-ent-gold-200 text-[11px] tracking-[0.3em] uppercase font-light ${isAr ? 'font-arabic' : ''}`}>
          {isAr ? 'جارٍ تحميل القائمة' : 'Loading menu'}
        </p>
      </div>
    </div>
  );
};

export default BrandLoader;
